<template>
  <div class="forget">
    <el-dialog title="" :visible.sync="dialogFormVisible" width="700px" modal-append-to-body append-to-body
      :close-on-click-modal="false">
      <div class="progess">
        <div v-for="(item, index) in progessList" class="progessItem" :key="index">
          <div class="line" v-if="index !== 0" :class="active >= index ? 'activeLine' : ''"></div>
          <div class="round" :class="active >= index ? 'activeRound' : ''">
            {{ index + 1 }}
          </div>
          <div class="name" :class="active >= index ? 'activeName' : ''">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="form">
        <el-form ref="form" :rules="formRules" :model="form">
          <el-form-item v-if="active === 0" label="" prop="phone">
            <el-input placeholder="请输入手机号" :maxlength="11" v-model="form.phone">
              <template slot="prepend">+86</template>
            </el-input>
            <!--            <el-input v-model="form.name" autocomplete="off"></el-input>-->
          </el-form-item>
          <el-form-item v-if="active === 0" label="" prop="code">
            <el-input style="width: 280px" placeholder="请输入验证码" v-model="form.code"></el-input>
            <el-button class="yzmButton" v-if="timeYzm === 0" type="primary" @click="getCode">获取验证码</el-button>
            <el-button class="yzmButton" v-else type="primary">{{ timeYzm }}s</el-button>
          </el-form-item>
          <el-form-item v-if="active === 1" label="" prop="password">
            <el-input :clearable="false" placeholder="长度8-16位，包含大小写字母、数字、符号" show-password type="password"
              v-model="form.password"></el-input>
          </el-form-item>
          <el-form-item v-if="active === 1" label="" prop="confirmPassword">
            <el-input :clearable="false" placeholder="请再次输入密码确认" show-password type="password"
              v-model="form.confirmPassword"></el-input>
          </el-form-item>
        </el-form>
        <div v-if="active === 2" class="successBack">
          <div>修改成功</div>
          <div @click="dialogFormVisible = false">回到登录页面（{{ backTime }}）s</div>
        </div>
      </div>
      <div v-if="active !== 2" class="nextButton">
        <el-button v-if="active !== 0" type="primary" @click="nextTop">上一步</el-button>
        <el-button type="primary" @click="nextBottom">下一步</el-button>
      </div>
      <div class="backLogin" @click="dialogFormVisible = false">
        {{ active === 2 ? "" : "返回登录" }}
      </div>
    </el-dialog>
    <tian-ai-captcha v-if="showCaptcha" @success="onCaptchaSuccess" @close="onCaptchaClose" />
  </div>
</template>

<script>
import { checkVerifyCode, executeUser, sendVerifyCode } from "@/api/supplierLogin";
import { aesEncrypt } from "@/utils/jsencrypt";
import TianAiCaptcha from "@/components/TianAiCaptcha";

export default {
  name: "Forget",
  components: {
    TianAiCaptcha,
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    const checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      }
      if (!/((^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$))/.test(value)) {
        callback(new Error("密码长度必须在8-16位，包含大小写字母、数字、特殊符号"));
      }
      callback();
    };
    const checkSurePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请确认密码"));
      }
      if (value !== this.form.password) {
        callback(new Error("密码不一致"));
      }
      callback();
    };
    return {
      backTime: 3,
      formRules: {
        phone: [{ required: true, validator: checkPhone }],
        password: [{ required: true, validator: checkPassword }],
        confirmPassword: [{ required: true, validator: checkSurePassword }],
        code: [{ required: true, message: "请输入验证码" }],
      },
      dialogFormVisible: false,
      active: 0,
      progessList: [{ name: "身份验证" }, { name: "重置密码" }, { name: "完成" }],
      timeInte: null,
      backInte: null,
      timeYzm: 0,
      showCaptcha: false,
      slideCaptchaData: null,
      form: {
        phone: "",
        password: "",
        confirmPassword: "",
        code: "",
      },
      phoneParam: {
        phone: "",
        code: "",
      },
    };
  },
  methods: {
    open(type) {
      console.log(type, "type");
      this.userType = type;
      this.dialogFormVisible = true;
      this.active = 0;
      this.form = {
        phone: "",
        code: "",
      };
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    getCode() {
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      this.showCaptcha = true;
    },
    onCaptchaSuccess(data) {
      this.showCaptcha = false;
      this.slideCaptchaData = data;
      this.sendPhoneCode();
    },
    onCaptchaClose() {
      this.showCaptcha = false;
    },
    sendPhoneCode() {
      if (!this.slideCaptchaData || !this.slideCaptchaData.uuid || !this.slideCaptchaData.code) {
        this.$message.error("滑块验证结果异常，请重试");
        return;
      }
      sendVerifyCode({
        phone: this.form.phone,
        uuid: this.slideCaptchaData.uuid,
        code: this.slideCaptchaData.code,
      }).then((res) => {
        this.timeYzm = 60;
        this.timeInte = setInterval(() => {
          this.timeYzm -= 1;
          if (this.timeYzm === 0) {
            clearInterval(this.timeInte);
            this.timeInte = null;
          }
        }, 1000);
      }).catch(() => {
        this.$message.error("验证码发送失败，请重试");
      }).finally(() => {
        this.slideCaptchaData = null;
      });
    },
    nextTop() {
      this.active = 0;
      this.timeYzm = 0;
      this.$refs.form.resetFields();
    },
    nextBottom() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.active === 0) {
            checkVerifyCode({
              phone: this.form.phone,
              code: this.form.code,
              userType: this.userType,
            }).then((res) => {
              this.phoneParam = {
                phone: this.form.phone,
                code: this.form.code,
              };
              this.active = 1;
              clearInterval(this.timeInte);
              this.$refs.form.resetFields();
            });
          }
          if (this.active === 1) {
            executeUser({
              phone: this.phoneParam.phone,
              code: this.phoneParam.code,
              password: aesEncrypt(this.form.password),
              confirmPassword: aesEncrypt(this.form.confirmPassword),
              userType: this.userType,
            }).then((res) => {
              this.active = 2;
              this.backInte = setInterval(() => {
                this.backTime -= 1;
                if (this.backTime === 0) {
                  this.dialogFormVisible = false;
                  clearInterval(this.backInte);
                  this.backInte = null;
                }
              }, 1000);
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.backLogin {
  text-align: center;
  color: #2d85f2;
  margin: 10px auto 100px auto;
  width: 80px;
  //height: 120px;
  cursor: pointer;
}

.nextButton {
  text-align: center;
}

.form {
  height: 150px;
  width: 400px;
  margin: 50px auto 0 auto;
}

.progess {
  height: 50px;
  display: flex;

  .progessItem {
    display: flex;
  }

  .line {
    width: 130px;
    height: 1px;
    margin: 14px 0 0 30px;
    background: #dfdfdf;
  }

  .activeLine {
    background: #2d85f2;
  }

  .round {
    height: 30px;
    width: 30px;
    line-height: 28px;
    margin-left: 20px;
    text-align: center;
    border-radius: 50%;
    background: #ffffff;
    border: 1px solid #d4d4d4;
    //cursor: pointer;
  }

  .activeRound {
    background: #2d85f2;
    border: 1px solid #2d85f2;
    color: #ffffff;
  }

  .name {
    margin: 5px 0 0 5px;
    //cursor: pointer;
    color: #8a8a8a;
  }

  .activeName {
    color: #262626;
  }
}

.yzmButton {
  margin-left: 10px;
  width: 110px;
  height: 35px;
}

.successBack {
  margin: 10px auto 100px auto;

  div:first-child {
    text-align: center;
    font-size: 30px;
    color: black;
    font-weight: bold;
  }

  div:last-child {
    text-align: center;
    font-size: 14px;
    color: #2d85f2;
  }
}
</style>
